<template>
  <div>
    <div class="actionForm">
    <template v-for="conf in configs" v-if="conf.configId == $route.params.id">
        <h2>Upload New <span class="lowerCase">postgresql.conf</span> File <span class="configName"> — {{ conf.name }}</span></h2>

        <div class="form">
          <ul class="textCenter">
            <li class="upload">
              <div class="uploadContainer" @drop.prevent="getDrop" @dragover.prevent>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><path fill="#00ADB5" d="M12.5,25C19.4,25,25,19.4,25,12.5S19.4,0,12.5,0S0,5.6,0,12.5S5.6,25,12.5,25z M14,17.5c0,0.3-0.2,0.5-0.5,0.5h-2c-0.3,0-0.5-0.2-0.5-0.5v-1c0-0.3,0.2-0.5,0.5-0.5h2c0.3,0,0.5,0.2,0.5,0.5V17.5z M8.7,11.1l3.5-3.9c0.2-0.2,0.5-0.2,0.7,0l0,0l3.5,3.9c0.2,0.2,0.2,0.5,0,0.7c-0.1,0.1-0.2,0.1-0.3,0.1h-2v2.6c0,0.3-0.2,0.5-0.5,0.5h-2.1c-0.3,0-0.5-0.2-0.5-0.5v-2.6H9c-0.3,0-0.5-0.2-0.5-0.5C8.5,11.3,8.6,11.2,8.7,11.1z"/></svg>
                <span>Drag your file here to upload, or <a href="#" title="Browse Files">browse files</a> from your computer.</span>
                <label for="uploadConf" class="uploadFile" title="Choose File">Choose File</label>
                <input id="uploadConf" type="file" ref="file" @change="uploadFile" required>
              </div>
              <!--<p class="formInfo">Accepted file types: <code>postgresql.conf</code> only.</p>-->
            </li>
            <li class="acceptedFile" v-if="file">
              <hr/>
              <div class="formLabel">Selected postgresql.conf File</div>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><path fill="#00ADB5" d="M12.5,0C5.6,0,0,5.6,0,12.5S5.6,25,12.5,25S25,19.4,25,12.5S19.4,0,12.5,0z M17.4,17.3c0,0.6-0.5,1.2-1.1,1.2H8.7c-0.6,0-1.1-0.5-1.1-1.2V7.7c0-0.6,0.5-1.2,1.1-1.2H14c0.3,0,0.6,0.1,0.8,0.3l2.3,2.4c0.2,0.2,0.3,0.5,0.3,0.8V17.3z"/><path fill="#00ADB5" d="M13.6,9.2V8H9.1v9h6.8v-6.6h-1.2C14.1,10.4,13.6,9.9,13.6,9.2z M10.2,9.3h2.3c0.2,0,0.4,0.3,0.4,0.5c0,0.3-0.2,0.5-0.4,0.5h-2.3c-0.2,0-0.4-0.3-0.4-0.5S10,9.3,10.2,9.3z M14.8,16.3L14.8,16.3h-4.5c-0.3,0-0.4-0.2-0.4-0.5c0-0.3,0.2-0.5,0.4-0.5l0,0h4.5c0.3,0,0.4,0.2,0.4,0.5C15.2,16.1,15.1,16.3,14.8,16.3z M14.8,14.8L14.8,14.8h-4.5c-0.3,0-0.4-0.2-0.4-0.5s0.2-0.5,0.4-0.5l0,0h4.5c0.3,0,0.4,0.2,0.4,0.5S15.1,14.8,14.8,14.8z M14.8,13.3L14.8,13.3h-4.5c-0.3,0-0.4-0.2-0.4-0.5s0.2-0.5,0.4-0.5l0,0h4.5c0.3,0,0.4,0.2,0.4,0.5S15.1,13.3,14.8,13.3z M15.2,11.3c0,0.3-0.2,0.5-0.4,0.5l0,0h-4.5c-0.3,0-0.4-0.2-0.4-0.5s0.2-0.5,0.4-0.5l0,0h4.5C15,10.8,15.2,11.1,15.2,11.3z"/></svg>
              <span id="fileName">{{ file.name }}</span>
            </li>
            <li>
              <!--<hr/>-->
              <p class="formInfo">Please note that this file will be saved to an existing configuration, and only the latest version of this file will be saved.</p>
              <input type="button" href="#" @click="sendFile" class="create btn" :disabled="!file" value="Upload File" title="Upload File">
              <router-link :to="($route.params.hasOwnProperty('id')) ? '/manage/config/'+$route.params.id : '/manage'" class="discard btnOutline" title="Cancel">Cancel</router-link>
            </li>
          </ul>

          <div id="dashboard" class="textCenter">
            <div class="or">
            <span>OR</span>
            </div>

            <h2>Add a new empty file</h2>
            <p>This action will create an empty <code>postgresql.conf</code> for this configuration,<br/>so you can add new params to it.</p>
            <button @click="uploadEmptyFile(conf.configId)" class="btn" title="New configuration">Create File</button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import store from '../store'
  import router from '../router'
  import { mixin } from '../components/mixins/mixin'

  export default {
    name: 'UploadConfig',

    mixins: [mixin],

    computed: { 
      configs () {
        return store.state.configs
      },
     
    },

    data: function() {
      return {
        file: null,
        test: '',
        pgVersion: ''
      }
    },
    
    methods: {
      getDrop() {
        this.file = event.dataTransfer.files[0];
      },

      uploadFile() {
        this.file = event.target.files[0]
      },

      sendFile() {
        let vc = this;
        
        //console.log(vc.file)
        const formData = new FormData()
        formData.append('file', vc.file, vc.file.name)

        axios.post(process.env.VUE_APP_API_URL+'/configs/'+vc.$route.params.id+'/postgresql.conf', formData, {
            headers: {
            'Authorization': 'Bearer '+store.state.authToken,
            //'Content-Type': 'multipart/form-data'
            },
        })
        .then( function(response){
            axios
            .get(process.env.VUE_APP_API_URL+'/configs/'+vc.$route.params.id+'/postgresql.conf', {
                headers: {
                    'Authorization': 'Bearer '+store.state.authToken
                }
            })
            .then( function(response){
              vc.notify('<p>File uploaded successfuly.</p>', true)
              router.push('/manage/config/'+vc.$route.params.id)
              $('.settingsMenu').removeClass('open')
              $('#app').removeClass('settings')
              store.commit('updateParams', {
                configId: vc.$route.params.id,
                params: response.data.params
              });
            }).catch(function(err) {
                vc.notify('<p>There was an error trying to upload your file.</p>', false, 'error')
                console.log(err);
            });

            //console.log(c)    
        }).catch(function(err) {
            console.log(err);
        });
      },

      uploadEmptyFile(configId) {
        this.createEmptyConfig(configId)
        router.push('/manage/config/'+configId)
      }

    },  
    mounted: function() {
      const vc = this;
    }

  }

</script>


<style scoped>

</style>
